module.exports = __webpack_public_path__ + "img/risk_img4.7bb6900c.png";